// Вкладка профиля хранится в ?tab=, чтобы ссылка и кнопка «Назад» возвращали в тот же раздел; license — прежнее имя из внешних ссылок
const TAB_SLUGS = {
	tabElement1: 'quotas',
	tabElement2: 'license',
	tabElement3: 'journals',
	tabElement4: 'handbooks',
	tabElement5: 'fines',
	tabElement6: 'customs',
	tabElement7: 'capacity',
	tabElement8: 'history',
}

export function tabFromQuery(query) {
	return Object.keys(TAB_SLUGS).find((tab) => TAB_SLUGS[tab] === query.tab) || null
}

export function syncTabQuery(router, route, tab) {
	const slug = TAB_SLUGS[tab]
	if (!slug || route.query.tab === slug) return
	router.replace({ query: { ...route.query, tab: slug } }).catch(() => {})
}
